/* eslint-disable import/no-unresolved */
import * as React from 'react';
import { withTranslation } from '@sailor/i18n-mach-pro';
import { CALCULATE_PRICE_STATUS, SHOP_ACTIVITY_TYPE } from '@/src/pages/shop/c_shop_golden/utils/constant';
import { safeJSONParse } from '@/src/pages/shop/c_shop_golden/utils';
import {
  GoodDetailGroupList, GoodDetailGroupSku, GoodDetailSkuList, SelectedGroupSkuList,
  BasicNutritionAllergenTypeEnum
} from '@/pages/shop/c_shop_golden/component';
import { MultiSkuStore } from '@/components/MultiSkuModalGolden/Store';
import GroupSkuStepper from '@/components/MultiSkuModalGolden/Components/AttrGroup/GroupSkuStepper';
import TrackUtils, { EVENT_TYPE } from '@/components/MultiSkuModalGolden/utils/TrackUtils';
import InfoModal from '@/components/MultiSkuModalGolden/Components/NutritionAllergenInfo/InfoModal';
import '@/components/MultiSkuModalGolden/Components/AttrGroup/index.css';
import { DietaryTagView } from '@/components/MultiSkuModalGolden/Components/DietaryTagView';

interface IProps {
  groupData: GoodDetailGroupList;
  changeSelectedAttrs: Function;
  skuId: number;
  lab: object; //埋点用
  store: MultiSkuStore;
  sku: GoodDetailSkuList;
  isMeetSillAmount: boolean;
  curSkuDiscountPriceIndex: number;
  count: number;
  onGroupCompleted?: (groupId: number) => void;
  getNextRequiredGroup?: (skuId: number, currentGroupId: number) => number | null;
}

interface IState {
  highLight: boolean;
  itemCountMap: SelectedGroupSkuList[]; //groupSkuList的状态数组
  showShakeAnimation?: boolean;
  // 因可能会有多条数据，需要记录具体是哪条item的icon被点击
  itemModalSpread: {
    [key: string]: boolean;
  };
  currentSpreadType: BasicNutritionAllergenTypeEnum; // 当前展开的类型
  iconCenterX: {
    [key in BasicNutritionAllergenTypeEnum]: number; // 营养成分/过敏源modal 分别记录left值
  };
  iconCenterY?: number; // 营养成分/过敏源modal top值
}

const Toast = Mach.requireModule('Toast');

/**
 * 复选选项组的加号icon状态
 */
const groupSkuAddIcon = {
  selectedAbleIcon: 'assets://shop/icon_multi_group_sku_selected_able.png', //已选可点击
  selectedUnableIcon: 'assets://shop/icon_multi_group_sku_selected_unable.png', //已选不可点击
  unselectedAbleIcon: 'assets://shop/icon_multi_group_sku_unselected_able.png', //未选可点击
  unselectedUnableIcon: 'assets://shop/icon_multi_group_sku_unselected_unable.png', //未选不可点击
};
class AttrGroup extends React.Component<any, IState> {
  refArray: any; //groupSku的ref数组
  multiSkuModalABTest: boolean; // 多规格页ab实验-置顶&锚定

  constructor(props: IProps) {
    super(props);
    const { store, skuId, groupData } = this.props;
    this.multiSkuModalABTest = store.multiSkuModalABTest || false;

    const selectedGroupList = store.getSelectedGroupListBySkuId(skuId);
    const selectedGroupSkuList = selectedGroupList.find(
      (item) => (item.groupId === groupData.groupId)
    )?.groupSkuList || [];
    const itemCountMap = this.setItemCountMap(selectedGroupSkuList, groupData);
    this.state = {
      highLight: false,
      itemCountMap,
      showShakeAnimation: false,
      itemModalSpread: {},
      currentSpreadType: BasicNutritionAllergenTypeEnum.Nutrition, // 当前展开的类型 默认营养成分
      iconCenterX: {
        [BasicNutritionAllergenTypeEnum.Nutrition]: 0,
        [BasicNutritionAllergenTypeEnum.Allergen]: 0,
      },
      iconCenterY: 0, // 营养成分/过敏源modal top值 默认0
    };
  }

  shouldComponentUpdate(nextProps: IProps, nextState: IState): boolean {
    const {
      groupData, changeSelectedAttrs, skuId, isMeetSillAmount, curSkuDiscountPriceIndex
    } = this.props;
    const propChange = nextProps.groupData !== groupData || nextProps.changeSelectedAttrs !== changeSelectedAttrs || nextProps.skuId !== skuId || nextProps.isMeetSillAmount !== isMeetSillAmount || nextProps.curSkuDiscountPriceIndex !== curSkuDiscountPriceIndex;
    // 更新state
    if (propChange) {
      const selectedGroupList = this.props.store.getSelectedGroupListBySkuId(nextProps.skuId);
      const selectedGroupSkuList = selectedGroupList.find((item) => (item.groupId === nextProps.groupData.groupId))?.groupSkuList || [];
      const itemCountMap = this.setItemCountMap(selectedGroupSkuList, nextProps.groupData);
      this.setState({
        itemCountMap,
      });
    }
    return propChange || nextState !== this.state;
  }

  /**
     * 复选group初始化
     * @param selectedGroupList 已选列表
     * @returns
     */
  setItemCountMap = (selectedGroupList: SelectedGroupSkuList[], groupData) => {
    // const { groupData } = this.props;
    const max = groupData.maxNumber;
    const min = groupData.minNumber;
    const tempMap = groupData.groupSkuList;
    this.refArray = Array(tempMap.length).fill(null).map(() => React.createRef());
    const countSum = selectedGroupList.reduce((total, item) => total + (item?.count || 0), 0);
    const isFull = countSum >= max;
    let shouldDisable;
    tempMap.forEach((item) => {
      if (selectedGroupList.length > 0) {
        const index = selectedGroupList.findIndex((i) => {
          if (i && item) {
            return i.groupSkuId === item.groupSkuId;
          } else {
            return false;
          }
        });
        //已选列表里有说明count存在，非复选的话count为1
        const groupSkuCount = index > -1 ? (selectedGroupList[index].count || 1) : 0;
        item.count = groupSkuCount;
        item.status = groupSkuCount > 0 ? 1 : 0;

        if (isFull) {
          item.addIcon = groupSkuCount > 0 ? groupSkuAddIcon.selectedUnableIcon : groupSkuAddIcon.unselectedUnableIcon;
        } else {
          item.addIcon = groupSkuCount > 0 ? groupSkuAddIcon.selectedAbleIcon : groupSkuAddIcon.unselectedAbleIcon;
        }
      } else {
        item.count = 0;
        item.status = 0;
        item.addIcon = groupSkuAddIcon.unselectedAbleIcon;
      }
    });
    //非复选的icon状态处理
    if (selectedGroupList.length > 0) {
      switch (true) {
        // 非必选但到达最大
        case min === 0 && max > 0 && selectedGroupList.length === max:
          shouldDisable = true;
          break;
        // 必选但非单选到达最大
        case min > 0 && max > 1 && selectedGroupList.length === max:
          shouldDisable = true;
          break;
        default:
          shouldDisable = false;
          break;
      }
      if (shouldDisable) {
        tempMap.forEach((item) => {
          item.status = item.status === 0 ? 2 : 1;
        });
      }
    }
    return tempMap;
  }

  hightLightBg = () => {
    this.setState({
      highLight: true,
    });
  }

  setShowShakeAnimation = () => {
    this.setState({
      showShakeAnimation: true
    });
  }

  componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<IState>, snapshot?: any) {
    if (this.state.showShakeAnimation) {
      this.setState({
        showShakeAnimation: false
      });
    }
  }

  render() {
    const { itemCountMap, itemModalSpread } = this.state;
    const {
      groupData, sku, isMeetSillAmount, curSkuDiscountPriceIndex
    } = this.props;
    const style = this.listUI().style;
    const bgStyle = this.listUI().bgStyle;
    const icon = this.listUI().icon;
    const repeatable = groupData.repeatable;
    const shakeClassname = this.state.showShakeAnimation ? 'shake-element' : '';
    const titles = this.getStatusText();
    return (
      <view className="sku-group">
        <view className="seperator-line" />
        <view className="group-title-container">
          <view className="title-container">
            <view style={{ flexDirection: 'column', maxWidth: 285 }}>
              <text className="group-title" content={groupData.groupName} />
            </view>
            <view className="group-tips">
              <view className={`status-btn ${shakeClassname}`} style={bgStyle}>
                {icon ? <image className="group-warning-icon" src={icon} /> : null}
                <text
                  className="status-text"
                  style={style}
                  content={titles.mainText}
                />
              </view>
              {
                titles.subText
                && (
                  <text
                    className="group-subtitle"
                    content={titles.subText}
                  />
                )
              }
            </view>
          </view>
        </view>
        <view className="group-content">
          {itemCountMap.map((item: SelectedGroupSkuList, index: number) => {
            const itemIcon = this.itemIcon(item.groupSkuId);
            const content = this.getItemText(item);
            const isFullDiscount = sku.activityInfoList?.[0]?.activityType === SHOP_ACTIVITY_TYPE.FULL_DISCOUNT;
            const isOriginPricePositive = item.originPrice?.amount > 0;
            const curCount = item?.count || 0;
            const addIcon = item?.addIcon || groupSkuAddIcon.unselectedAbleIcon;
            const wholeCount = itemCountMap.reduce((total, item) => total + item.count, 0);
            const disAbleText = (groupData.repeatable === 1) && (curCount === 0) && (wholeCount === groupData.maxNumber);
            const textStyle = { color: (this.itemStatus(item.groupSkuId) === 2 || disAbleText) ? '#808080' : '#222222' };
            const hotTagInfo = item.extraInfo?.hotTagInfo;
            // 是否显示菜品要素信息
            const showDietaryTag = this.hasDietaryTag(item);
            return (
              // eslint-disable-next-line react/jsx-key
              <view
                className="group-item-container"
                style={{ borderBottom: (index === groupData.groupSkuList.length - 1) ? '0' : '0.6 solid #00000014' }}
              >
                <view
                  className="group-item"
                  style={{
                    paddingBottom: showDietaryTag ? '0' : '16'
                  }}
                  onClick={() => { this.clickSkuItem(item); }}
                >
                  <view className="group-item-name-cust-container">
                    <text className={disAbleText ? 'group-item-text-disable' : 'group-item-text'} style={textStyle} content={item.name} />
                    {
                      hotTagInfo?.title
                        ? (
                          <view className="group-item-hot-wrapper">
                            <image className="group-item-hot-icon" src={hotTagInfo?.icon} />
                            <text className="group-item-hot-text" content={hotTagInfo.title} />
                          </view>
                        )
                        : null
                    }
                    {/* 展示 营养成分/过敏源 modal */}
                    {itemModalSpread[item.groupSkuId] && this.renderInfoModal(item)}
                  </view>
                  <view className="group-item-padding" style={{ flexShrink: 0 }}>
                    {
                      // 是满折菜品，且达到满折条件，且原价大于0
                      isFullDiscount && isMeetSillAmount && isOriginPricePositive
                        ? (
                          <view className="group-item-price-container">
                            <text className="group-item-discount-price-text" content={`+${item?.discountPriceList?.[curSkuDiscountPriceIndex]?.discountPrice?.displayText}`} />
                            <text className="group-item-min-price-text" content={`+${item?.originPrice.displayText}`} />
                          </view>
                        )
                        : <text className="group-item-price-text" content={content} />
                    }
                    {!(repeatable && item) ? <image className="group-item-status-icon" src={itemIcon} />
                      : (
                        <view>
                          <GroupSkuStepper
                            ref={this.refArray[index]}
                            addIcon={addIcon}
                            curCount={curCount}
                          />
                        </view>
                      )}
                  </view>
                  {/* 使用透明的absolute来扩大按钮热区 */}
                  {/*// ----- mpweb适配change -----*/}
                  {!!repeatable && (
                    <view
                      className="add-btn-hitslop" onClick={() => {
                        this.calRepeatableSku(item, true);
                      }}
                    />
                  )}
                  {/*// ----- mpweb适配change -----*/}
                  {!!repeatable && curCount > 0 && (
                    <view
                      className="dec-btn-hitslop" onClick={() => {
                        this.calRepeatableSku(item, false);
                      }}
                    />
                  )}
                </view>
                {/* 展示卡路里 营养成分/过敏源 标题&icon */}
                {showDietaryTag ? this.renderDietaryTagView(item) : null}
              </view>
            );
          })}
        </view>
      </view>
    );
  }

  /**
   * 是否有菜品要素标签
   * @param item
   * @returns
   */
  hasDietaryTag = (item) => {
    const { extraInfo, calorie } = item || {};
    const {
      burnoutDurationInfo, nutritionInfo, allergiesInfo, caffeineInfo, sodiumInfo
    } = extraInfo || {};
    return Boolean(calorie || burnoutDurationInfo?.title || nutritionInfo?.title || allergiesInfo?.title
      || caffeineInfo?.title || sodiumInfo?.title);
  }

  /**
   * 渲染标签
   * @param item
   * @returns
   */
  renderDietaryTagView = (item) => {
    const { extraInfo, calorie } = item || {};
    const {
      skuId, spuId, shopId, source
    } = this.props;
    // 标签数据
    const tagData = {
      calorie,
      ...(extraInfo || {})
    };
    return (
      <view className="dietary-tag-container">
        <DietaryTagView
          data={tagData}
          source={source}
          shopId={shopId}
          spuId={spuId}
          skuId={skuId}
          groupSkuId={item.groupSkuId}
          maxWidth={Mach.env.screenWidth - 52}
          onClickTagIcon={this.onModalSpreadChange}
        />
      </view>
    );
  }

  /** 营养成分/过敏源modal */
  renderInfoModal = (item) => {
    const { iconCenterX, iconCenterY = 0, currentSpreadType } = this.state;
    const { extraInfo, groupSkuId } = item || {};

    return (
      <InfoModal
        currentSpreadType={currentSpreadType}
        groupSkuId={groupSkuId}
        extraInfo={extraInfo}
        onModalSpreadChange={this.onModalSpreadChange}
        iconCenterX={iconCenterX}
        iconCenterY={iconCenterY}
      />
    );
  }

  /** 处理是否点开查看 营养成分/过敏源
   * @param isSpread 是否展开
   * @param iconCenterX icon中心点 x 坐标 用于定位modal
   * @param iconCenterY icon中心点 y 坐标 用于定位modal
   * @param type 类型 Nutrition | Allergen
   */
  onModalSpreadChange = (params) => {
    const {
      isSpread,
      iconCenterX,
      iconCenterY,
      type,
      groupSkuId
    } = params;
    this.setState((prevState) => ({
      itemModalSpread: {
        ...prevState.itemModalSpread,
        [groupSkuId]: isSpread,
      },
      currentSpreadType: type,
      iconCenterX: {
        ...prevState.iconCenterX,
        [type]: iconCenterX,
      },
      iconCenterY,
    }));
  }

  /**
     * 点击选项组内sku加减号
     * @param groupSkuItem 当前加减的sku
     * @param isAdd 是否是加购（true加购false减购）
     * @param index 当前item的index
     * @returns
     */
  private calRepeatableSku = (groupSkuItem: GoodDetailGroupSku, isAdd: boolean) => {
    const prevCount = groupSkuItem.count; // 记录操作前的count值
    const {
      groupData, changeSelectedAttrs, lab, store, source
    } = this.props;
    const { itemCountMap } = this.state;
    const curSumCount = itemCountMap.reduce((total, obj) => total + obj.count, 0);
    const isFull = curSumCount >= groupData.maxNumber;

    if ((isFull && isAdd) || (!isAdd && curSumCount <= 0) || (store.getCalStatus() === CALCULATE_PRICE_STATUS.LOADING)) {
      return;
    }

    TrackUtils.reportStepper(EVENT_TYPE.MC, {
      ...lab,
      button_name: isAdd ? 0 : 1,
      group_sku_id: groupSkuItem.groupSkuId,
      sku_number: this.props.count
    });

    itemCountMap.forEach((countArr) => {
      const newSumCount = isAdd ? curSumCount + 1 : curSumCount - 1;
      const newIsFull = newSumCount >= groupData.maxNumber;
      if (countArr.groupSkuId === groupSkuItem.groupSkuId) {
        const newCount = isAdd ? countArr.count + 1 : countArr.count - 1;
        countArr.count = newCount;
        if (newIsFull) {
          countArr.addIcon = newCount > 0 ? groupSkuAddIcon.selectedUnableIcon : groupSkuAddIcon.unselectedUnableIcon;
        } else {
          countArr.addIcon = newCount > 0 ? groupSkuAddIcon.selectedAbleIcon : groupSkuAddIcon.unselectedAbleIcon;
        }
      } else {
        if (newIsFull) {
          countArr.addIcon = countArr.count > 0 ? groupSkuAddIcon.selectedUnableIcon : groupSkuAddIcon.unselectedUnableIcon;
        } else {
          countArr.addIcon = countArr.count > 0 ? groupSkuAddIcon.selectedAbleIcon : groupSkuAddIcon.unselectedAbleIcon;
        }
      }
    });
    const calPriceParam = itemCountMap.filter((item) => item.count !== 0);
    changeSelectedAttrs(groupData.groupId, calPriceParam, () => {
      this.setState({
        itemCountMap,
      }, () => {
        this.handleGroupCompletion(groupData.groupId);
      });

      // 获取操作后的count值 用于埋点上报
      const currentItem = itemCountMap.find((i) => i.groupSkuId === groupSkuItem.groupSkuId);
      const newCount = currentItem?.count || 0;
      // 当count值发生0↔1变化时上报
      if (prevCount !== newCount && (prevCount === 0 || newCount === 0)) {
        const logData = safeJSONParse(groupSkuItem?.extraInfo?.logData);
        TrackUtils.reportSkuSelectMC(source, {
          ...lab,
          group_sku_id: groupSkuItem.groupSkuId,
          button_reaction: newCount > 0 ? 1 : 0,
          is_popular_spu: logData?.popular_option || 0
        });
      }
    });
  }

  //点击选择sku的逻辑（非复选情况）
  private clickSkuItem = (groupItem: GoodDetailGroupSku) => {
    const prevCount = groupItem.count; // 记录操作前的count值
    const {
      groupData, changeSelectedAttrs, t, store, lab, source
    } = this.props;
    if ((store.getCalStatus() === CALCULATE_PRICE_STATUS.LOADING) || (groupData.repeatable === 1)) {
      return;
    }
    const { itemCountMap } = this.state;
    const status = itemCountMap.find((item) => (item.groupSkuId === groupItem.groupSkuId))?.status;
    const single = groupData.minNumber === 1 && groupData.maxNumber === 1;
    if (groupData.groupSkuList.length === groupData.minNumber) {
      Toast.show(t('cartlayer_select_5'), 2);
      return;
    }
    if ((single && status === 1) || (!single && status === 2)) {
      return;
    }
    switch (true) {
      case single && status === 0:
        itemCountMap.forEach((item) => { item.status = item.groupSkuId === groupItem.groupSkuId ? 1 : 0; });
        break;
      case groupData.minNumber === 0 && groupData.maxNumber === 1: // 可选，最多只有一个的场景
        itemCountMap.forEach((item) => {
          if (item.status == 1) {
            item.status = 0;
          } else {
            item.status = item.groupSkuId === groupItem.groupSkuId ? 1 : 0;
          }
        });
        break;
      case !single && status === 0:
        itemCountMap.forEach((item) => { if (item.groupSkuId === groupItem.groupSkuId) { item.status = 1; } });
        if (itemCountMap.filter((temp) => (temp.status === 1)).length === groupData.maxNumber) {
          itemCountMap.forEach((item) => { item.status = item.status === 0 ? 2 : 1; });
        }
        break;
      case !single && status === 1:
        itemCountMap.forEach((item) => {
          if (item.groupSkuId === groupItem.groupSkuId || item.status === 2) {
            item.status = 0;
          }
        });
        break;
      default:// 应该包含单选已选中 || 多选不可点击状态
        break;
    }

    itemCountMap.forEach((unReatableItem) => {
      unReatableItem.count = unReatableItem.status === 1 ? 1 : 0;
    });
    const calPriceParam = itemCountMap.filter((item) => item.count !== 0);
    if (calPriceParam) {
      changeSelectedAttrs(groupData.groupId, calPriceParam, () => {
        this.setState({
          itemCountMap,
        }, () => {
          this.handleGroupCompletion(groupData.groupId);
        });

        // 获取操作后的count值 用于埋点上报
        const currentItem = itemCountMap.find((i) => i.groupSkuId === groupItem.groupSkuId);
        const newCount = currentItem?.count || 0;

        // 当count值发生0↔1变化时上报
        if (prevCount !== newCount && (prevCount === 0 || newCount === 0)) {
          const logData = safeJSONParse(groupItem?.extraInfo?.logData);
          TrackUtils.reportSkuSelectMC(source, {
            ...lab,
            group_sku_id: groupItem.groupSkuId,
            button_reaction: newCount > 0 ? 1 : 0,
            is_popular_spu: logData?.popular_option || 0
          });
        }
      });
    }
  }

  // groupSku的文案
  private getItemText = (item: GoodDetailGroupSku) => {
    const { t } = this.props;
    return (item.originPrice?.amount > 0 ? `+${item.originPrice.displayText}` : '');
  }

  //判断当前item是否被选中
  private itemStatus = (skuId: number): number => {
    const { itemCountMap } = this.state;
    const status = itemCountMap.find((item) => (item.groupSkuId === skuId))?.status || 0;
    return status;
  }

  /**
     * 非复选状态
     * @param status //0-未选中，1-选中， 2-多选置灰（未选）
     * @returns
     */
  private itemIcon = (skuId: number) => {
    const { groupData } = this.props;
    let statusIcon;
    const status = this.itemStatus(skuId);
    if (this.props.groupData.maxNumber === 1 && this.props.groupData.minNumber === 1) {
      statusIcon = status === 1 ? 'assets://shop/icon_multi_sku_single_selected.png' : 'assets://shop/icon_multi_sku_single.png';
    } else if (groupData.minNumber === 0 && groupData.maxNumber === 1) { // 可选，最多可选一个
      statusIcon = status === 1 ? 'assets://shop/icon_multi_sku_single_selected.png' : 'assets://shop/icon_multi_sku_single.png';
    } else {
      statusIcon = status === 1 ? 'assets://shop/icon_multi_sku_multi_selected.png' : (status === 0 ? 'assets://shop/icon_multi_sku_multi.png' : 'assets://shop/icon_multi_sku_multi_unable.png');
    }
    return statusIcon;
  }

  //选择状态文案
  private getStatusText = () => {
    const { groupData, t } = this.props;
    const { itemCountMap } = this.state;
    const min = groupData.minNumber;
    const max = groupData.maxNumber;
    const current = itemCountMap.reduce((total, obj) => total + obj.count, 0);
    const left = this.props.groupData.minNumber - current;
    const leftText = current === 0 ? t('cartlayer_select_5a', { pluralCount: min, confirm: min }) : t('cartlayer_select_6b', { pluralCount: left, confirm: left });
    let subText = '';
    let mainText = '';
    let i18nMainTextId = '';
    switch (true) {
      case min === 0:
        i18nMainTextId = 'cartlayer_select_optional';
        subText = t('cartlayer_select_10a', { pluralCount: max, confirm: max }); //可选项，最多选max件
        mainText = t(i18nMainTextId);
        break;
      case min === max:
        subText = left === 0 ? '' : leftText; //必选项，已完成 || 还需选left件 || 仅选min件
        mainText = left === 0 ? t('cartlayer_select_done') : t('cartlayer_select_required');
        break;
      case min < max && current === 0:
        subText = t('cartlayer_select_4', { min, max }); //必选项，最少选min件，最多选max件
        mainText = t('cartlayer_select_required');
        break;
      case min < max && current < min: //必选项，还需要选${left}件
        subText = t('cartlayer_select_6b', { pluralCount: left, confirm: left });
        mainText = t('cartlayer_select_required');
        break;
      case min <= current && current < max: //必选项，已完成，还可选${max - current}件
      {
        const num = max - current;
        subText = t('cartlayer_select_7a', { pluralCount: num, confirm: num });
        mainText = t('cartlayer_select_done');
        break;
      }
      case min < max && current === max: //必选项，已完成
        // text = t('cartlayer_select_done');
        mainText = t('cartlayer_select_done');
        break;
      default:
        subText = '🐱未曾设想的情况🐱';
        break;
    }
    return {
      subText,
      mainText,
      i18nMainTextId
    };
  }

  // group状态样式
  private listUI = (): any => {
    const { groupData } = this.props;
    const { itemCountMap } = this.state;
    const curCount = itemCountMap.reduce((total, obj) => total + obj.count, 0);
    const isChecked = curCount >= groupData.minNumber;
    const { highLight } = this.state;
    const {
      i18nMainTextId
    } = this.getStatusText();
    let style;
    let backgroundStyle;
    let btnIcon;
    switch (true) {
      case i18nMainTextId.includes('optional'):
        style = {
          fontFamily: 'KeeTa-Bold',
          fontWeight: 700,
          color: '#222222',
          fontSize: 12
        };
        backgroundStyle = {
          backgroundColor: '#ffffff',
          paddingLeft: '8',
          border: '0.5 solid #CACACA'
        };
        break;
      case isChecked:
        style = {
          fontFamily: 'KeeTa-Regular',
          fontWeight: 400,
          color: '#3F9A47',
          fontSize: 12,
        };
        backgroundStyle = {
          backgroundColor: '#EFF9EF',
        };
        btnIcon = this.props.groupData.minNumber === 0 ? '' : 'assets://shop/icon_done.png';
        break;
      case highLight:
        style = {
          fontFamily: 'KeeTa-Bold',
          fontWeight: 500,
          color: '#D90012',
          fontSize: 12,
        };
        backgroundStyle = {
          backgroundColor: '#FFF0F1',
        };
        btnIcon = 'assets://shop/icon_multi_sku_group_error.png';
        break;
      default:
        style = {
          fontFamily: 'KeeTa-Bold',
          fontWeight: 500,
          color: '#222222',
          fontSize: 12,
        };
        backgroundStyle = {
          backgroundColor: '#FFFABF',
        };
        btnIcon = 'assets://shop/icon_multi_sku_group_warning.png';
        break;
    }

    return {
      style,
      bgStyle: backgroundStyle,
      icon: btnIcon
    };
  }

  /**
   * 判断子规格组是否选择完毕
   * @returns 是否完成
   */
  private isGroupCompleted = (): boolean => {
    const { groupData } = this.props;
    const { itemCountMap } = this.state;
    const current = itemCountMap.reduce((total, obj) => total + obj.count, 0);
    return current >= groupData.maxNumber;
  }

  /**
   * 处理子规格组是否选择完毕后的逻辑
   * @param groupId 当前组ID
   */
  private handleGroupCompletion = (groupId: number) => {
    // 「多规格页ab实验-置顶&锚定」为false，或者当前组未选择完成，则直接返回
    if (!this.multiSkuModalABTest || !this.isGroupCompleted()) {
      return;
    }

    const { skuId, getNextRequiredGroup, onGroupCompleted } = this.props;
    const nextGroupId = getNextRequiredGroup?.(skuId, groupId); // 获取下一个必选项组

    if (nextGroupId) {
      onGroupCompleted?.(nextGroupId); // 触发锚定
    }
  }
}

export default withTranslation('', {
  withRef: true,
})(AttrGroup);
